import * as React from "react";
import { Button, Popconfirm } from "antd";
import { TCaseDecisionPresentationModel } from "../../presenter/model/CaseDecisionPresentationModel";
import { IOrganisation } from "../../../organisations/model/Organisation";
import { ICourtCase } from "../../../caseLawDocuments/model/CourtCase";
import { IDocumentType } from "../../../documentTypes/model/DocumentType";
import {
  CloudFilled,
  DeleteOutlined,
  EditOutlined,
  EyeFilled,
  LockFilled
} from "@ant-design/icons";
import { CaseDecisionStatus } from "../../common/Constants";
import { IUser } from "../../../user/model/User";

const CaseDecisionSidebar = ({
  translate,
  caseDecision,
  onEditClick,
  onArchiveClick,
  removeCaseDecision,
  publishCaseDecision,
  user,
  onUndoClick
}: {
  translate;
  caseDecision: TCaseDecisionPresentationModel;
  caseDecisionTypes: IDocumentType[];
  organisations: IOrganisation[];
  courtCase: ICourtCase;
  onEditClick?: any;
  onArchiveClick?: any;
  removeCaseDecision?: any;
  publishCaseDecision: any;
  user?: IUser;
  onUndoClick?: any;
}) => {
  return (
    <div style={{ marginTop: 24, marginLeft: 24 }}>
      {caseDecision.status !== CaseDecisionStatus.ARCHIVED && (
        <Button
          value=""
          shape={"round"}
          type="link"
          onClick={() => onEditClick(caseDecision.id)}
        >
          <EditOutlined style={{ marginRight: 5 }} />{" "}
          {translate("editors.case_law_documents.edit")}
        </Button>
      )}
      <br />
      {(user?.isAdmin() || user?.isOperator()) &&
        caseDecision.status !== CaseDecisionStatus.ARCHIVED && (
          <Popconfirm
            title={translate("editors.case_decisions.delete_confirm")}
            onConfirm={() => removeCaseDecision()}
            okText={translate("editors.case_law_documents.confirm")}
            cancelText={translate("editors.case_law_documents.cancel")}
          >
            <Button value="" type="link" shape={"round"}>
              <DeleteOutlined style={{ marginRight: 5 }} />{" "}
              {translate("editors.case_law_documents.delete")}
            </Button>
          </Popconfirm>
        )}
      <br />
      {caseDecision.status !== CaseDecisionStatus.ARCHIVED && (
        <Popconfirm
          title={translate("editors.case_law_documents.archive_confirm")}
          onConfirm={() => onArchiveClick(caseDecision)}
          okText={translate("editors.case_law_documents.confirm")}
          cancelText={translate("editors.case_law_documents.cancel")}
        >
          <Button value="" type="link" shape={"round"}>
            <LockFilled style={{ marginRight: 5 }} />{" "}
            {translate("editors.case_law_documents.archive")}
          </Button>
        </Popconfirm>
      )}
      <br />
      {caseDecision.status === CaseDecisionStatus.VERIFIED && (
        <Button
          shape={"round"}
          type={"link"}
          onClick={() => publishCaseDecision(caseDecision.id)}
        >
          <EyeFilled style={{ marginRight: 5 }} />{" "}
          {translate("editors.case_law_documents.publish")}
        </Button>
      )}
      <br />
      {caseDecision.status === CaseDecisionStatus.PUBLISHED && (
        <Button
          className={"case-law-document-revert-status-btn"}
          shape={"round"}
          type={"link"}
          onClick={() => onUndoClick(caseDecision.id)}
        >
          <CloudFilled style={{ marginRight: 5 }} />{" "}
          {translate("editors.case_law_documents.revert_status")}
        </Button>
      )}
    </div>
  );
};
export default CaseDecisionSidebar;
